export const MONTH_AND_DAY_FORMAT = "MMM dd";
export const YEAR_MONTH_DAY_FORMAT = "yyyy-MM-dd";
export const API_DATE_FORMAT = "yyyy-MM-dd";
export const MONTH_AND_DATE_YEAR_FORMAT = "MMM dd, yyyy";
export const BOOKING_DETAILS_CHECKIN_FORMAT = "EEE dd MMM";
export const BOOKING_DETAILS_CHECKOUT_FORMAT = "EEE dd MMM yyyy";
